export const boolToInt = (b: boolean) => (b ? 1 : 0);
